import { z } from "zod";
import { ActivityListSchema } from "./ActivityLog";
import { DisbursementHistoryListSchema } from "./DisbursementHistory";
import { TodaysFlexRowsSchema } from "./FlexRows";
import { AgingProjectSchema, ProjectSummaryAdminListSchema } from "./Projects";
import { TodaysRemindersSchema } from "./Reminder";

export const ProjectAgingRangeSchema = z.object({
  days: z.number(),
  months: z.number(),
  years: z.number(),
});

export const AdminDashboardSchema = z.object({
  projects: ProjectSummaryAdminListSchema,
  projectReminders: TodaysRemindersSchema,
  flexRows: TodaysFlexRowsSchema,
  activityLog: ActivityListSchema,
  paymentData: DisbursementHistoryListSchema,
  agingProjects: z.array(AgingProjectSchema),
  projectAgingRange: ProjectAgingRangeSchema,
});

export type AdminDashboard = z.infer<typeof AdminDashboardSchema>;
export type ProjectAgingRange = z.infer<typeof ProjectAgingRangeSchema>;
